import CardImg from '../assets/images/card.svg';
import VisaImg from '../assets/images/visa.svg';
import MastercardImg from '../assets/images/mastercard.svg';
import AmexImg from '../assets/images/amex.svg';
import DiscoverImg from '../assets/images/discover.svg';

export const checkCardType = (data) => {
    let cardNumber = data.replace(/\s+/g, '');

    if (cardNumber.match(new RegExp('^4')) !== null) {
        return { type: 'Visa', img: VisaImg };
    }

    if (cardNumber.match(new RegExp('^2[2-7]')) !== null || cardNumber.match(new RegExp('^5[1-5]')) !== null) {
        return { type: 'MasterCard', img: MastercardImg };
    }

    if (cardNumber.match(new RegExp('^3[47]')) !== null) {
        return { type: 'American Express', img: AmexImg };
    }

    if (cardNumber.match(new RegExp('^6(011|4|5)')) !== null) {
        return { type: 'Discover', img: DiscoverImg };
    }

    return { type: 'default', img: CardImg }
}

export const checkCardNumberLength = (type, isLength) => {
  
    if (type === 'Visa' || type === 'MasterCard' || type === 'Discover') {
        if (isLength === 16) {
            return true;
        }
    }
    if (type === 'American Express') {
        if (isLength === 15) {
            return true;
        }
    }
}

export const checkCardCVVlength = (cardType, cvvLength) => {

    if (cardType === 'American Express') {
        if (cvvLength === 4) {
            return true;
        }
    } else {
        if (cardType !== 'default') {
            if (cvvLength === 3) {
                return true;
            }
        }
    }
}

export const checkCardDate = (date) => {

    let getMonth = Number(date.split('/')[0]);
    let getYear = Number(date.split('/')[1]);

    let currentMonth = new Date().getMonth() + 1;
    let currentYear = new Date().getFullYear() % 100;

    if (getMonth > 0 && getMonth < 13) {
        if (getYear > currentYear) {
            return true;
        } else if (getYear === currentYear) {
            if (getMonth >= currentMonth) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    } else {
        return false;
    }
}